export default __webpack_public_path__ + "static/churn-optimized-bb9ab5167a6cff2f6db491f4dc8b8e7d.jpg";